module.exports = __webpack_public_path__ + "img/header.5701e139.jpg";